import { Routes } from "@angular/router";

export const authRoutes: Routes = [
	{
		path: "",
		redirectTo: "login",
		pathMatch: "full",
	},
	{
		path: "login",
		title: "auth.login.title",
		children: [
			{
				path: "",
				loadComponent: () => import("./pages/internal/login/login.component").then((c) => c.Login),
			},
		],
	},
];
